import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setupAxiosInterceptor } from "../api/api";
import Header from "../components/header";
import "../styles/admin.css";

const alphabet = "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЮЯ".split("");

const Admin = () => {
  const [words, setWords] = useState([]);
  const [search, setSearch] = useState("");
  const [newWord, setNewWord] = useState("");
  const [newDefinition, setNewDefinition] = useState("");
  const [newRegion, setNewRegion] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");

  useEffect(() => {
    setupAxiosInterceptor(navigate);
  }, [navigate]);

    /* ===============================
     LOAD REGIONS (CACHED)
     TODO add another item for date and then compare with current date.
     if current date is greater with 4 hours than date_item the remove all items and reload all
     =============================== */
    useEffect(() => {
      const cached = localStorage.getItem("regions");
      if (cached) {
        setRegions(JSON.parse(cached));
      } else {
        loadRegions();
      }
    }, []);

    const loadRegions = async () => {
      try {
        const res = await api.get("/dictionary/getregions");
        setRegions(res.data || []);
        localStorage.setItem("regions", JSON.stringify(res.data || []));
      } catch {
        console.error("Грешка при зареждане на региони.");
      }
    };
  /* ===============================
     SEARCH
     =============================== */
  const searchWords = async () => {
    if (!search) {
      setWords([]);
      setMessage("Въведете дума за търсене.");
      return;
    }
    try {
      const res = await api.get("/dictionary/search", {
        params: { term: search }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
    }
  };
   /* ===============================
     FILTER BY LETTER
     =============================== */
  const filterByLetter = async (letter) => {
    setSearch("");
    try {
      const res = await api.get(`/dictionary/searchbyletter/${letter}`);
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
    }
  };
  /* ===============================
     CLEAR
     =============================== */
  const clearAll = () => {
    setSearch("");
    setSelectedRegion("");
    setWords([]);
    setMessage("");
  };

  const addWord = async () => {
    if (!newWord) {
      setMessage("Въведете дума");
      return;
    }
    try {
      await api.post("/dictionary/addtofile", {
        term: newWord,
        definition: newDefinition,
        region: newRegion
      });
      setNewWord("");
      setNewDefinition("");
      setNewRegion("");
      setWords([]);
      setMessage("Думата е добавена");
    } catch {
      setMessage("❌ Грешка при добавяне");
    }
  };

  const deleteWord = async (id) => {
    try {
      await api.delete(`/dictionary/delete?id=${id}`);
      setWords(words.filter(w => w.id !== id));
    } catch {
      setMessage("❌ Грешка при изтриване");
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    delete api.defaults.headers.common["Authorization"];
    navigate("/login");
  };

  return (
    <div className="page-background">
      <div className="admin-container">
        <Header />

        <p>
            <select style={{maxWidth: "50%"}}
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
              >
                <option value="">-- Всички региони --</option>
                {regions.map(r => (
                  <option key={r} value={r}>{r}</option>
                ))}
            </select>
        </p> 
        {/* Alphabet */}
        <div className="alphabet-bar">
          {alphabet.map(letter => (
            <button
              key={letter}
              onClick={() => filterByLetter(letter)}
              className="alphabet-btn"
            >
              {letter}
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="search-bar">
          <input
            type="text"
            placeholder="Търсене на дума..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setMessage("");
            }}
          />
          <div className="search-buttons">
            <button onClick={searchWords}>Търсене</button>
            <button onClick={clearAll}>
              Изчистване
            </button>
          </div>
        </div>

        {message && <p className="message">{message}</p>}

        {/* Words */}
        <ul className="word-list">
          {words.map(w => (
            <li key={w.id} className="word-card">
              <div className="word-content">
                <strong><u>{w.term}</u></strong>
                <p><i>Регион:</i> {w.region}</p>
                <p><i>Определение:</i> {w.definition}</p>
              </div>
              {token && (
                <button
                  className="delete-btn"
                  onClick={() => deleteWord(w.id)}
                >
                  Изтриване
                </button>
              )}
            </li>
          ))}
        </ul>

        {/* Add Word */}
        <div className="add-word">
          <h3>Добави дума</h3>
          <input
            type="text"
            placeholder="Дума"
            value={newWord}
            onChange={(e) => setNewWord(e.target.value)}
          />
          <input
            type="text"
            placeholder="Регион"
            value={newRegion}
            onChange={(e) => setNewRegion(e.target.value)}
          />
          <textarea
            rows={4}
            placeholder="Определение"
            value={newDefinition}
            onChange={(e) => setNewDefinition(e.target.value)}
          />
          <button onClick={addWord}>Запис</button>
          <button onClick={logout} className="logout-btn">
            Изход
          </button>
        </div>
      </div>
    </div>
  );
};

export default Admin;
